import wrapper from 'wrapper';
import events from '../../events-emitter';

class InputHandler {
    constructor(region) {
        this.dropdown = wrapper.select('.regions-dropdown');
        this.dropdown.addEventListener('change', (evt) => {
            const { value } = evt.target.options[evt.target.selectedIndex]; /* eslint no-param-reassign: "error" */
            evt.regionId = value;
            events.emit('updated-dropdown', evt);
        });
        this.buttons = wrapper.selectAll('button.summary--item');
        this.buttons.forEach(button => {
            button.addEventListener('click', (evt) => {
                evt.dataKey = evt.target.getAttribute('data-key'); /* eslint no-param-reassign: "error" */
                events.emit('updated-buttons', evt);
            });
        });

        if (region) {
            this.setRegion(region);
        }
    }

    setRegion(region) {
        for (let i = 0; i < this.dropdown.options.length; i++) {
            const option = this.dropdown.options[i];
            if (option.value === region) {
                this.dropdown.selectedIndex = i;
                events.emit('updated-dropdown', { regionId: region });
                return;
            }
        }
    }
}

export default InputHandler;
